const { REPUTATION_ACTIONS } = require('./constants');

const reputationPermissions = (action, permissions, institutionId, year) => {
  if (action === 'reputation:viewProduct' &&
    permissions[institutionId].some(item => item.includes('REPUTATION_'))
  ) {
    return true;
  }

    if (
    REPUTATION_ACTIONS.some((reputationAction) =>
      action.includes(reputationAction),
    ) &&
    permissions[institutionId].includes(`REPUTATION_${year}`)
  ) {
    return true;
  }

  return false;
};

module.exports = {
  reputationPermissions,
};
